import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoLocaServerConnectionWarning.styles";
import WifiOffOutlinedIcon from "@mui/icons-material/WifiOffOutlined";

export const NoLocalServerConnectionWarning = ({ isBrokerConnected }: { isBrokerConnected: boolean }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.warningContainer}>
            <WifiOffOutlinedIcon className={classes.icon} />
            <Typography className={classes.warningTitle} variant="subtitle2">
                {!isBrokerConnected ? t("HMI.no_connection_to_the_broker") : t("HMI.no_connection_to_the_localserver")}
            </Typography>
        </Box>
    );
};
